import { render, staticRenderFns } from "./HeaderPageTitle.vue?vue&type=template&id=bcd0ef1e&"
import script from "./HeaderPageTitle.vue?vue&type=script&lang=js&"
export * from "./HeaderPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports